/* LOT 71 · P9 · jamais d'image cassée : une image qui ne répond pas disparaît, la carte garde son dégradé (et son bouton « Ajouter une photo » quand il existe) */
const PIXEL = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export const installerImagesSures = () => {
  document.addEventListener('error', (e) => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.ko) return;
    img.dataset.ko = '1';
    img.classList.add('img-ko');
    const parent = img.parentElement;
    if (parent) parent.classList.add('a-img-ko');
    img.src = PIXEL;
  }, true);
};
